import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Tags, SlidersHorizontal } from 'lucide-react';
import ExpenseCategories from './ExpenseCategories';
import ExpenseSettings from './ExpenseSettings';

const OfficeExpenseManagement = () => {
  const [activeTab, setActiveTab] = useState('categories');

  return (
    <div className="space-y-6" data-testid="office-expense-management-page">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Expense Settings</h1>
        <p className="text-gray-600 dark:text-gray-400">
          Manage expense categories and approval thresholds for your office
        </p>
      </div>

      <Card>
        <CardContent className="pt-6">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-2 max-w-md">
              <TabsTrigger value="categories" className="flex items-center gap-2" data-testid="tab-expense-categories">
                <Tags className="h-4 w-4" />
                Categories
              </TabsTrigger>
              <TabsTrigger value="thresholds" className="flex items-center gap-2" data-testid="tab-expense-thresholds">
                <SlidersHorizontal className="h-4 w-4" />
                Approval Caps
              </TabsTrigger>
            </TabsList>

            <TabsContent value="categories" className="mt-6">
              <ExpenseCategories officeLevel={true} />
            </TabsContent>

            <TabsContent value="thresholds" className="mt-6">
              <ExpenseSettings officeLevel={true} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default OfficeExpenseManagement;
